import React, { useEffect, useState } from "react"
import MultiSelect from "../../../../components/atoms/MultiSelect.atom"

const TeamMemberPicker = ({
  teamMembers,
  selectedTeamMembers,
  setSelectedTeamMembers,
}) => {
  const [label, setLabel] = useState("Todos")
  const id = `team-member-picker-${new Date().getTime()}`
  useEffect(() => {
    if (selectedTeamMembers.length === 0) {
      setLabel("Todos")
    } else if (selectedTeamMembers.length === 1) {
      const name = teamMembers
        .flatMap((member) => member.items)
        .find(
          (member) => member.teamMemberTagName === selectedTeamMembers[0]
        ).teamMemberName
      setLabel(name)
    } else if (selectedTeamMembers.length < teamMembers.length) {
      setLabel(`${selectedTeamMembers.length} integrantes seleccionados`)
    } else if (selectedTeamMembers.length === teamMembers.length) {
      setLabel("Todos")
    }
  }, [selectedTeamMembers])
  const labelTemplate = () => {
    return (
      <span className="overflow-hidden white-space-nowrap text-overflow-ellipsis">
        <i className="pi pi-user mr-2"></i>
        {label}
      </span>
    )
  }
  return (
    <MultiSelect
      inputId={id}
      className="team-member-picker"
      value={selectedTeamMembers}
      disabled={teamMembers.length === 0}
      optionGroupChildren="items"
      optionGroupLabel="active"
      optionGroupTemplate={(option) => {
        return <div>{option.active ? "Activo" : "Inactivo"}</div>
      }}
      scrollHeight="430px"
      options={teamMembers}
      onChange={(e) => setSelectedTeamMembers(e.value)}
      optionLabel="teamMemberName"
      optionValue="teamMemberTagName"
      panelClassName="team-member-picker-panel-consumo-por-integrante max-w-23rem"
      placeholder={labelTemplate()}
      maxSelectedLabels={0}
      selectedItemsLabel={labelTemplate()}
    />
  )
}

export default TeamMemberPicker
